<template>
  <div>
    <div class="my-6">
      <div class="text-white">{{ usuario.nombre }} {{ usuario.apellido }}</div>
      <span class="inline-block bg-gray-100 rounded-full px-3 py-1 text-md font-bold text-teal-700 mb-2">
        {{ currency(usuario.saldo, { decimal: ",", separator: "." }).format() }}
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="sync"
          @click="refrescar"
          class="inline-block ml-2 w-4 h-4"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            fill="green"
            d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
          ></path>
        </svg>
      </span>
      <span> </span>
    </div>
    <OpcionMenu titulo="Mi cuenta" descripcion="Recargas, retiros y salir del sistema" to="/micuenta" desactivado="false" />
    <OpcionMenu titulo="Apostar" descripcion="Colocar una apuesta en una carrera" to="/carreras" :desactivado="apuestasDesactivadas" />
    <OpcionMenu titulo="Transmisión" descripcion="Canal exclusivo de las reuniones vigentes" to="/transmision" desactivado="false" />
    <OpcionMenu titulo="Programas" descripcion="Programas y tabuladas de la jornada" to="/programa" desactivado="false" />
    <OpcionMenu titulo="Resultados" descripcion="Sports de las carreras" to="/resultados" desactivado="false" />
    <OpcionMenu titulo="Historial" descripcion="Resumen de operaciones en la cuenta" to="/historial" desactivado="false" />
    <OpcionMenu titulo="Ayuda y soporte" descripcion="Información para aprovechar la plataforma" to="/ayuda" desactivado="false" />
    <div class="mx-6 mt-10">
      <p v-html="mensaje" class="text-sm text-yellow-200" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OpcionMenu from "@/components/OpcionMenu";
import currency from "currency.js";

export default {
  components: {
    OpcionMenu
  },
  data() {
    return {
      currency: currency
    };
  },
  methods: {
    refrescar() {
      this.$store.dispatch("refrescarSaldo");
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.sesion.usuario,
      mensaje: state => state.sesion.mensajeEstado,
      apuestasDesactivadas: state => state.sesion.usuario.geoControl.accion === "NO_HABILITADA" || state.sesion.usuario.datosPersonales.accion !== "OK"
    })
  }
};
</script>
